import Column from "./Column";
import Columns from "./Columns";
import Search from "./Search";
import Navigation from "./Navigation";
import Copyright from "./Copyright";
import PoweredBy from "./PoweredBy";
import PressLogo from "./PressLogo";
import Socials from "./Socials";

export default {
  Column,
  Columns,
  Search,
  Navigation,
  Copyright,
  PoweredBy,
  PressLogo,
  Socials
};
